import React from 'react'
import Nav from './Nav'

const ContactUs = () => {
  return (
    <div className='bg'>
      <Nav />
      <h1>ContactUs</h1>
    </div>
  )
}

export default ContactUs
